import { CommonModule, DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BCLedgerFilter } from "../../../../core/models/bcLedgers/bclegderfilter";
import { Router } from "@angular/router";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { FormsModule } from "@angular/forms";
import { Select, SelectModule } from "primeng/select";
import { Employee } from "../../../../core/models/profile/employee";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { DatePickerModule } from "primeng/datepicker";

@Component({
  selector: "jni-bcledger-filter",
  templateUrl: "./bcledger-filter.component.html",
  styleUrls: ["./bcledger-filter.component.scss"],
  providers: [DatePipe],
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    CardModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    DatePickerModule,
  ],
})
export class BcledgerFilterComponent implements OnInit {
  @ViewChild("filter") filter!: Select;
  @Input() fromDate!: string;
  @Input() toDate!: string;
  @Input() bcSelectedId!: string;
  @Input() selectedDateRange!: string;
  @Input() showHeading = true;
  @Input() showBrandingConsultantDropDown = true;
  @Input() showBrandingConsultantWhoSupportsMeDropDown = false;
  @Input() invokeAtLoad = false;
  @Input() isFromBCLedger = true;
  @Input() isBAC = false;
  @Input() isManager = false;
  @Input() overrideManager = false;
  @Input() showRemoveFilter = false;
  bcLedgerForm: BCLedgerFilter = {};
  @Input() bcList!: Employee[];
  @Input() manager = false;
  @Input() showSupportDashboardButton = false;
  @Input() userRole = 0;
  @Input() callDateSelection = true;
  @Input() fromManagerView = false;
  @Input() disableDropDown = false;
  @Input() isSuperManager = false;
  @Input() fromManager = false;
  @Output() bcLedgerFormEvent = new EventEmitter<BCLedgerFilter>();
  @Output() removeFilterEvent = new EventEmitter<boolean>();
  @Output() removeFilterButtonEvent = new EventEmitter<boolean>();
  @Output() bcSelectedEvent = new EventEmitter<boolean>();
  @Output() showFilterButton = new EventEmitter<boolean>();
  @Output() redirectToSupportDashboard = new EventEmitter<BCLedgerFilter>();
  dateRange = [
    // {
    //   id: 1,
    //   name: "",
    // },
    {
      id: 2,
      name: "Current YTD",
    },
    {
      id: 3,
      name: "Current MTD",
    },
    {
      id: 4,
      name: "Previous YTD",
    },
    {
      id: 5,
      name: "Previous MTD",
    },
  ];
  showLoader = false;

  constructor(
    public datepipe: DatePipe,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.setToAndFromDates();
    this.initizeDate();
  }

  // ngOnChanges(): void {
  //   this.setToAndFromDates();
  // }

  setToAndFromDates() {
    if (!this.fromDate) {
      this.fromDate = this.transformDateFormat(new Date()) ?? "";
    } else {
      this.fromDate = this.transformDateFormat(this.fromDate) ?? "";
    }
    if (!this.toDate) {
      this.toDate = this.transformDateFormat(new Date()) ?? "";
    } else {
      this.toDate = this.transformDateFormat(new Date()) ?? "";
    }
  }

  initizeDate() {
    this.bcLedgerForm = {
      fromDate: this.datepipe.transform(this.fromDate, "MM/dd/yyyy") ?? "",
      toDate: this.datepipe.transform(this.toDate, "MM/dd/yyyy") ?? "",
      brandingConsultantID: this.bcSelectedId ?? "",
      dateRange: this.selectedDateRange,
    };
    if (this.callDateSelection) {
      this.onDateRangeSelection(this.selectedDateRange);
    }
    if (this.invokeAtLoad) {
      this.bcLedgerFormEvent.emit(this.bcLedgerForm);
    }
  }

  onDateRangeSelection(range: string) {
    if (!this.filter?.overlayVisible) {
      if (range === "Current YTD") {
        const curDate = new Date();
        let currentYear = curDate.getFullYear();
        if (curDate.getMonth() < 3) {
          currentYear = curDate.getFullYear() - 1;
        }
        const date = new Date(`April 1 ${currentYear}`);
        this.fromDate = this.transformDateFormat(date) ?? "";
        this.toDate = this.transformDateFormat(new Date()) ?? "";
        this.patchValueInDate();
      } else if (range === "Current MTD") {
        this.toDate = this.transformDateFormat(new Date()) ?? "";
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        this.fromDate = this.transformDateFormat(firstDay) ?? "";
        this.patchValueInDate();
      } else if (range === "Previous YTD") {
        const curDate = new Date();
        let currentFromYear = curDate.getFullYear() - 1;
        let currentToYear = curDate.getFullYear();

        if (curDate.getMonth() < 3) {
          currentFromYear = curDate.getFullYear() - 2;
          currentToYear = curDate.getFullYear() - 1;
        }

        const currentFromDate = new Date(`April 1 ${currentFromYear}`);
        this.fromDate = this.transformDateFormat(currentFromDate) ?? "";

        const currentToDate = new Date(`March 31 ${currentToYear}`);
        this.toDate = this.transformDateFormat(currentToDate) ?? "";
        this.patchValueInDate();
      } else if (range === "Previous MTD") {
        const date = new Date();
        this.fromDate =
          this.transformDateFormat(
            new Date(date.getFullYear(), date.getMonth() - 1, 1)
          ) ?? "";
        this.toDate =
          this.transformDateFormat(
            new Date(date.getFullYear(), date.getMonth(), 0)
          ) ?? "";
        this.patchValueInDate();
      }
    }
  }

  patchValueInDate() {
    this.bcLedgerForm = {
      fromDate: this.datepipe.transform(this.fromDate, "MM/dd/yyyy") ?? "",
      toDate: this.datepipe.transform(this.toDate, "MM/dd/yyyy") ?? "",
      brandingConsultantID: this.bcSelectedId ?? "",
      dateRange: this.selectedDateRange,
    };
  }

  patchDate(fromdate: string, toDate: string) {
    this.fromDate = fromdate;
    this.toDate = toDate;
    this.bcLedgerForm = {
      fromDate: this.datepipe.transform(this.fromDate, "MM/dd/yyyy") ?? "",
      toDate: this.datepipe.transform(this.toDate, "MM/dd/yyyy") ?? "",
    };
  }

  onFromDateSelection(event: Event) {
    const target = event.target as HTMLInputElement;
    const date = new Date(
      `${target?.value}T00:00:00`.replace(/-/g, "/").replace(/T.+/, "")
    );
    this.bcLedgerForm.fromDate =
      this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    // this.bcLedgerForm.fromDate = new Date(
    //   event.target.value
    // ).toLocaleDateString();
  }

  onToDateSelection(event: Event) {
    const target = event.target as HTMLInputElement;
    const date = new Date(
      `${target?.value}T00:00:00`.replace(/-/g, "/").replace(/T.+/, "")
    );
    this.bcLedgerForm.toDate =
      this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    // this.bcLedgerForm.toDate = new Date(
    //   event.target.value
    // ).toLocaleDateString();
  }

  switchToManagerView() {
    this._router.navigate(["dashboard-poc/manager-report"]);
  }

  switchToSupportDashboard() {
    this._router.navigate(["dashboard-poc"]);
  }

  onSubmit() {
    this.showLoader = true;
    this.bcLedgerForm.brandingConsultantID = this.bcSelectedId;
    this.bcLedgerForm.dateRange = this.selectedDateRange;
    if (
      this.userRole != UserRole.Admin &&
      this.fromManagerView &&
      !this.isSuperManager
    ) {
      this.redirectToSupportDashboard.emit(this.bcLedgerForm);
      this.showLoader = false;

      return;
    }
    this.bcLedgerFormEvent.emit(this.bcLedgerForm);
    this.removeFilterEvent.emit(false);
    this.showFilterButton.emit(true);
    this.showLoader = false;
  }

  removeFilter() {
    this.removeFilterEvent.emit(true);
  }

  removeFilterButton() {
    this.removeFilterButtonEvent.emit(true);
  }

  bcSelected() {
    this.bcSelectedEvent.emit(true);
  }

  transformDateFormat(date: string | Date | number) {
    return this.datepipe.transform(date, "MM/dd/yyyy");
  }
}
